import devConfig from './config.dev'
import prodConfig from './config.prod'

let config
/* global process */
if (process.env.NODE_ENV === 'production') {
  config = prodConfig
} else {
  config = devConfig
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js